export default "__VITE_ASSET__CA25IEV0__"